<template>
    <v-menu
        bottom right offset-y nudge-bottom="23px"
        transition="slide-y-transition"
        max-height="calc(100vh - 88px)"
        content-class="menu-panel"
        :close-on-content-click="false"
        @input="value => isMenuOpened = value"
        :value="isMenuOpened"
    >
        <template v-slot:activator="{on, attrs}">
            <v-btn
                large plain class="rounded-lg"
                :style="{backgroundColor: isMenuOpened ? '#1976d2' : '', marginRight: '10px', minWidth: 'auto', paddingLeft: '12px', paddingRight: '12px'}"
                v-bind="attrs" v-on="on"
            >
                <v-tooltip bottom>
                    <template v-slot:activator="{on, attrs}">
                        <v-icon v-bind="attrs" v-on="on">mdi-cog</v-icon>
                    </template>
                    <span>Администрирование</span>
                </v-tooltip>
            </v-btn>
        </template>

        <v-container fluid class="panel-heading">
            <h3>Администрирование</h3>
        </v-container>

        <div>
            <router-link to="/device-groups" is="v-btn" large plain block tile class="justify-start" @click="hideMenu">
                <v-icon>mdi-access-point-network</v-icon> &nbsp;Группы устройств
            </router-link>
            <router-link to="/devices" is="v-btn" large plain block tile class="justify-start" @click="hideMenu">
                <v-icon>mdi-access-point</v-icon> &nbsp;Устройства
            </router-link>
            <router-link to="/packets" is="v-btn" large plain block tile class="justify-start" @click="hideMenu">
                <v-icon>mdi-receipt-text-send</v-icon> &nbsp;Пакеты данных
            </router-link>
            <router-link to="/users" is="v-btn" large plain block tile class="justify-start" @click="hideMenu">
                <v-icon>mdi-account-group</v-icon> &nbsp;Пользователи
            </router-link>
        </div>
    </v-menu>
</template>


<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class AdminWidget extends Vue
{
    isMenuOpened = false

    hideMenu() {
        this.isMenuOpened = false
    }
}
</script>
